import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-99" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-100" data-mp="1cfjc815yagoc">
        <h2 className="text-center font-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-101" data-mp="1ccdnwo55bito">
          Najczęstsze pytania
        </h2>

        <div className="mt-8 divide-y divide-chem/15 border-y border-chem/15" data-id="element-102" data-mp="253f8x5vis8l4">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-103" data-mp="205vpzsnvn7mu" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[52px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-104" data-mp="1v5rdedq3ax1w">
                  <span className="text-sm font-semibold text-ink sm:text-base" data-id="element-105" data-mp="1kn70s1bbitoe">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-106" data-mp="1pncuro528s9n">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="1arn59g0o1x06" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="1fqqbh3sdu99q" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-109" data-mp="16o7bcrfzear6">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-110" data-mp="rzb775h1phvu">
                      <p className="pb-4 text-sm leading-relaxed text-ink/70" data-id="element-111" data-mp="mz6l8zxdbuy8">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}